import { Injectable } from '@angular/core';
import { FeUtil, TYPE } from '../../../hezky-routes';

@Injectable({ providedIn: 'root' })
export class PermissionService {

    constructor(private feUtil: FeUtil) { }

    hasPermission(permission: TYPE.AppRoutePermission): boolean {
        if (!permission) return true;

        const user = this.feUtil.user_data;
        const applications = this.feUtil.applications;

        if (!user || !Array.isArray(applications) || applications.length === 0) return false;

        const userApplicationsSet = new Set(applications.map((app: TYPE.Application) => app.name));
        const allowedProducts = permission.allowedProducts;

        const productAllowed = !allowedProducts || allowedProducts.some(product => userApplicationsSet.has(product));
        if (productAllowed && allowedProducts?.length === 1) {
            const targetProduct = allowedProducts[0];
            const application = applications.find((app: TYPE.Application) => app.name === targetProduct) || null;
            if (application) this.feUtil.switchApplication(application.id);
        }

        const accessAllowed = !permission.accessRight || permission.accessRight.some(r => user.userRoles && typeof user.userRoles.privilege !== 'undefined' ? user.userRoles.privilege === r : false);
        return productAllowed && accessAllowed;
    }
}
